import axios from "@/plugins/axios";

let url = "/api/v1/dshop/products";

export const products = {
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
    get(data){
        return axios.get(`${url}/${data._id}`, data).then(result => result.data);
    },
}
